export default __webpack_public_path__ + "static/media/img3.4861ae77.svg";